// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__TriPi","inner":"Footer_inner__3kYEY"};